import { defineComponent as _defineComponent } from 'vue';
import { createElementVNode as _createElementVNode, renderSlot as _renderSlot, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Transition as _Transition, withCtx as _withCtx, createVNode as _createVNode, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
var _withScopeId = function (n) { return (_pushScopeId("data-v-3ed78e52"), n = n(), _popScopeId(), n); };
var _hoisted_1 = { class: "dropdown-container__header" };
var _hoisted_2 = { class: "dropdown-container__content" };
var _hoisted_3 = { class: "dropdown-container__footer" };
import { computed, ref, watch, nextTick } from 'vue';
import useClickOutside from '../../hooks/useClickOutside';
import useLiveElementRect from '../../hooks/useLiveElementRect';
import useFocusTrap from '../../hooks/useFocusTrap';
export default /*#__PURE__*/ _defineComponent({
    __name: 'DropdownContainer',
    props: {
        open: { type: Boolean },
        fullScreen: { type: Boolean },
        class: {}
    },
    emits: ["click:outside"],
    setup: function (__props, _a) {
        var emit = _a.emit;
        var props = __props;
        var onClickOutside = useClickOutside().onClickOutside;
        var dropdownRef = ref(null);
        var measureRef = ref(null);
        var _b = useLiveElementRect(measureRef), boxRect = _b[0], updatePosition = _b[1];
        var position = computed(function () {
            if (boxRect.value) {
                var screenCenter = window.innerWidth / 2;
                var boxCenter = boxRect.value.left + boxRect.value.width / 2;
                if (screenCenter > boxCenter) {
                    return 'left';
                }
                else if (screenCenter < boxCenter) {
                    return 'right';
                }
                else {
                    return 'center';
                }
            }
            return 'center';
        });
        var _c = useFocusTrap(), clearFocusTrap = _c.clearFocusTrap, initFocusTrap = _c.initFocusTrap, trapRef = _c.trapRef;
        watch(function () { return props.open; }, function (open) {
            if (open) {
                nextTick(function () {
                    initFocusTrap();
                    updatePosition();
                });
            }
            else {
                nextTick(function () {
                    clearFocusTrap();
                });
            }
        });
        onClickOutside(dropdownRef, function () {
            emit('click:outside');
        });
        return function (_ctx, _cache) {
            return (_openBlock(), _createElementBlock(_Fragment, null, [
                _createElementVNode("div", {
                    ref_key: "measureRef",
                    ref: measureRef,
                    class: "dropdpown-measure"
                }, null, 512 /* NEED_PATCH */),
                _createVNode(_Transition, {
                    name: _ctx.fullScreen ? 'slide-left' : 'fade',
                    appear: ""
                }, {
                    default: _withCtx(function () { return [
                        (_ctx.open)
                            ? (_openBlock(), _createElementBlock("div", {
                                key: 0,
                                ref_key: "dropdownRef",
                                ref: dropdownRef,
                                class: _normalizeClass(["overlay-panel dropdown-container", [
                                        _ctx.fullScreen ? 'dropdown-container--full-screen' : '',
                                        _ctx.fullScreen ? 'overlay-panel--full-screen' : '',
                                        'dropdown-container--' + position.value,
                                        props.class,
                                    ]])
                            }, [
                                _createElementVNode("div", {
                                    ref_key: "trapRef",
                                    ref: trapRef,
                                    class: "dropdown-container__inner"
                                }, [
                                    _createElementVNode("div", _hoisted_1, [
                                        _renderSlot(_ctx.$slots, "header")
                                    ]),
                                    _createElementVNode("div", _hoisted_2, [
                                        _renderSlot(_ctx.$slots, "default")
                                    ]),
                                    _createElementVNode("div", _hoisted_3, [
                                        _renderSlot(_ctx.$slots, "footer")
                                    ])
                                ], 512 /* NEED_PATCH */)
                            ], 2 /* CLASS */))
                            : _createCommentVNode("v-if", true)
                    ]; }),
                    _: 3 /* FORWARDED */
                }, 8 /* PROPS */, ["name"])
            ], 64 /* STABLE_FRAGMENT */));
        };
    }
});
